/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import * as actionTypes from './FuneralService-ActionTypes';

export const triggerGetViewTime = (data) => ({
    type: actionTypes.ENTERPRISE_GET_VIEW_TIME,
    data,
});

export const triggerDeleteViewTime = (data) => ({
    type: actionTypes.ENTERPRISE_DELETE_VIEW_TIME,
    data,
});

export const updateFuneralServiceTime = (data) => ({
    type: actionTypes.ENTERPRISE_UPDATE_FUNERAL_SERVICE_TIME,
    data,
});
